// extracted by mini-css-extract-plugin
export default {"disableTextSelection":"Stylesheet_disableTextSelection__qXIYt"};